/*
 * © 2021 Sukoa AG <Interactive Technologies> http://www.sukoa.com
 */

import DataLayerEvent from "../DataLayerEvent";

class BeginCheckoutDL extends DataLayerEvent {
    constructor(ecommerce) {
        super();
        this.ecommerce = ecommerce;
    }

    generateParameters() {
        this.getParameters().event = 'begin_checkout';
        this.getParameters().ecommerce = this.ecommerce;
    }

}

export default BeginCheckoutDL;
